import api from 'api';

export const loadCreativePerformance = api(
  'GET /api/gallery-creatives/performance/:id'
);
